<div class="m-2">
    <div class="row">
        <div class="col-sm-4">
            <app-staff-member [selectedStaff]="staff"></app-staff-member>
        </div>

        <div class="col-sm-8" *ngIf="requestedAppointment">
            <div class="row">
                <div class="col-sm-4">
                    <mat-icon>health_and_safety</mat-icon><span>Treatment type</span>
                </div>
                <div class="col-sm-8">
                    {{ requestedAppointment.treatmentType }}
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <mat-icon>credit_card</mat-icon><span>Price</span>
                </div>
                <div class="col-sm-8">
                    £{{ requestedAppointment.price }}
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <mat-icon>event</mat-icon><span>Start Time</span>
                </div>
                <div class="col-sm-8">
                    {{ requestedAppointment.startTime | date : "EEEE, MMMM d, y h:mm a" }}
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <mat-icon>alarm</mat-icon><span>Duration</span>
                </div>
                <div class="col-sm-8">
                    {{ requestedAppointment.duration }} minutes
                </div>
            </div>
        </div>

    </div>

    <div *ngIf="loggedIn && !appointmentSaved">
        <div class="row my-5">
            <div class="col-sm-5 mb-2">
                <button mat-raised-button class="w-100"
                    (click)="goBack()"><mat-icon>arrow_back</mat-icon>Back</button>
            </div>
            <div class="col-sm-2"></div>
            <div class="col-sm-5">
                <button mat-raised-button color="primary" class="w-100" (click)="saveAppointment()">Request
                    Appointment</button>
            </div>
        </div>
    </div>
</div>